import { render, staticRenderFns } from "./vinegar-warning.vue?vue&type=template&id=b080529a&scoped=true&lang=pug&"
import script from "./vinegar-warning.vue?vue&type=script&lang=coffee&"
export * from "./vinegar-warning.vue?vue&type=script&lang=coffee&"
import style0 from "./vinegar-warning.vue?vue&type=style&index=0&id=b080529a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080529a",
  null
  
)

export default component.exports